import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'feature_flags';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  private flags = signal<Set<string>>(this.load());

  isEnabled(flag: string): boolean {
    return this.flags().has(flag);
  }

  enable(flag: string): void {
    this.flags.update((f) => new Set([...f, flag]));
    this.save();
    console.log(`[features] "${flag}" enabled`);
  }

  disable(flag: string): void {
    this.flags.update((f) => {
      const s = new Set(f);
      s.delete(flag);
      return s;
    });
    this.save();
    console.log(`[features] "${flag}" disabled`);
  }

  list(): string[] {
    return [...this.flags()];
  }

  private load(): Set<string> {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return new Set(raw ? JSON.parse(raw) : []);
    } catch {
      return new Set();
    }
  }

  private save(): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...this.flags()]));
  }
}
